import React from 'react';
import { BUTTON_CLASSES } from 'scy/buttons';
import { hidden, tablet_inlineBlock } from 'scy/display.mod.scss';

export default function LoginButton() {
  return (
    <a
      className={`${hidden} ${tablet_inlineBlock} ${
        BUTTON_CLASSES.altSecondary
      }`}
      href="/login"
    >
      Log In
    </a>
  );
}
